module.exports = __webpack_public_path__ + "static/media/ticketing-license.7db0ca98.png";